import type { Translations } from './zh';

export const es: Translations = {
  bubble: {
    open: 'Abrir chat',
    close: 'Cerrar chat',
    badge: 'En línea',
    dragHint: 'Mantén pulsado para arrastrar',
  },
  panel: {
    closeAria: 'Cerrar panel de chat',
    languageAria: 'Seleccionar idioma',
    welcomeFallback: 'Hola, ¿en qué puedo ayudarle?',
    quickQuestionsTitle: 'Puede probar estas preguntas',
    quickAskTitle: 'Preguntas rápidas',
    inputPlaceholder: 'Escriba su pregunta...',
    sendButton: 'Enviar',
    sendAria: 'Enviar mensaje',
    onlineStatus: 'En línea',
    thinkingAria: 'Pensando',
    aiBusyHint: 'El agente está respondiendo, espere por favor…',
    leadReopenHint: 'Deje sus datos de contacto aquí cuando lo necesite',
    startChat: 'Consultar ahora',
    welcomeQuickHint: 'Vista rápida',
    videoPreparing: 'Preparando el vídeo…',
    newMessageTitle: '💬 Nuevo mensaje',
    newMessageBody: 'Tiene un nuevo mensaje. Haga clic para verlo.',
  },
  roles: {
    visitor: 'Visitante',
    ai: 'Asistente de IA',
    human: 'Agente',
    system: 'Sistema',
  },
  web: {
    aiChat: 'Soporte IA',
    humanChat: 'Agente',
    switchToHuman: 'Cambiar a agente',
    switchToAI: 'Volver a la IA',
    resetChat: 'Reiniciar chat',
    commonQuestions: 'Preguntas frecuentes',
    faqTitle: 'Preguntas frecuentes (FAQ)',
    selectLanguage: 'Seleccionar idioma',
    maximize: 'Maximizar',
    restore: 'Restaurar',
    offlineLabel: 'Sin conexión',
    aiGreeting: '¡Hola! Soy su asistente de IA. ¿En qué puedo ayudarle?',
    humanGreeting: 'Hola, le hemos conectado con un agente. ¿En qué puedo ayudarle?',
    agentOffline: 'Agente sin conexión',
    agentOfflineMessage: 'Lo sentimos, nuestros agentes están desconectados. Escanee el código QR para contactarnos por WeChat.',
    wechatPrompt: 'Escanear para WeChat',
    wechatHint: 'Use WeChat para escanear y añadir al agente',
    serviceHoursLabel: 'Horario de atención: ',
    viewImage: 'Ver imagen',
    playVideo: 'Reproducir vídeo',
    closeViewer: 'Cerrar',
    downloadFile: 'Descargar',
    fileTypePdf: 'Documento PDF',
    fileTypeWord: 'Documento de Word',
    fileTypeExcel: 'Hoja de cálculo de Excel',
    fileTypePpt: 'Presentación de PowerPoint',
    fileTypeArchive: 'Archivo comprimido',
    fileTypeGeneric: 'Archivo',
  },
  leadCard: {
    ariaForm: 'Formulario de contacto',
    title: 'Deja tus datos de contacto',
    nameLabel: 'Nombre',
    namePlaceholder: 'Tu nombre',
    phoneLabel: 'Teléfono',
    phonePlaceholder: 'Tu número de teléfono',
    phoneError: 'Introduce un número de teléfono válido',
    submit: 'Enviar',
    submitting: 'Enviando…',
    dismiss: 'Más tarde',
    success: '¡Gracias! Nuestro asesor se pondrá en contacto contigo pronto.',
  },
};
